import DraftHeader from './DraftHeader';

export default DraftHeader;
